import React, { useState, useEffect } from "react";

import Dropdown from "react-bootstrap/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import { getResponseSurvesByPatient } from "../services/providerService";

import { Link, useNavigate, useLocation } from "react-router-dom";
import eyeimg from "../../images/eye.svg";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import CustomPagination from "../../Common/Component/CustomPagination/CustomPagination";
import "./surveyList.css";
import Loader from "../../utils/Loader";

function ResponseSurveyList({ patient }) {
  const userdata = useSelector((state) => state);
  const navigate = useNavigate();
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [editData, setEditData] = useState(null);

  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [surveyList, setSurveyList] = useState([]);
  const token = useSelector((state) => state?.login?.data?.accessToken);
  const [selectedSortValue, setSelectedSortValue] = useState("");

  const { data } = useSelector((state) => state.login);

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    _getSurveyList();
  }, [page, limit]);

  const _getSurveyList = async (searchText, sortby) => {
    setLoading(true);
    const respose = await getResponseSurvesByPatient({
      page: page + 1,
      limit,
      searchKey: searchText,
      sortBy: sortby,
      patient: patient,
    });
  
    if (respose?.status === "SUCCESS") {
      setSurveyList(respose?.data?.list);
      setTotalPages(respose?.data?.totalPages || 0);
      setTotalItems(respose?.data?.totalItems || 0);
    }
    setLoading(false);
  };

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchText(query);
    if (query.length >= 3 || query.length === 0) {
      setLoading(true);
      _getSurveyList(query, selectedSortValue);
    }
    setLoading(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  const redirectToResponseList = (survey) => {
    navigate("/admin/patient/response-list", { state: { survey: survey } });
  };

  const handleSelect = (eventKey) => {
   
    setSelectedSortValue(eventKey); // Update the state with the selected value
    _getSurveyList(searchText, eventKey);
  };

  const [show, setShow] = useState(false);

  return (
    <div className="Dashboard-wrapper">
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="add-doctor">
            <Form>
              <Form.Group controlId="searchInput">
                <Form.Control
                  type="search"
                  aria-label="Search"
                  value={searchText}
                  onChange={handleSearchChange}
                  placeholder="Search survey by title..."
                />
              </Form.Group>
            </Form>

            {/* Button to trigger modal */}

            <Dropdown
              className="patient-info-dropdown "
              onSelect={handleSelect}
            >
              <Dropdown.Toggle className="db-dropdown h-100 ">
                {selectedSortValue === ""
                  ? "Sort By"
                  : selectedSortValue === "name-asc"
                  ? "Name A-Z"
                  : "Name Z-A"}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item eventKey="">Default</Dropdown.Item>
                <Dropdown.Item eventKey="name-asc">Name A-Z</Dropdown.Item>
                <Dropdown.Item eventKey="name-dsc">Name Z-A</Dropdown.Item>
                {/* <Dropdown.Item eventKey="low-icbps">Low ICBPS</Dropdown.Item> */}
              </Dropdown.Menu>
            </Dropdown>
          </div>

          <div className="table-responsive dashboard-table">
            <table className="patients-table">
              <thead>
                <tr className="t-row-block">
                  <th scope="col">Sr No</th>
                  <th scope="col">Title</th>
                  <th scope="col">Description</th>
                  <th scope="col">Date</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                {surveyList.length > 0 ? (
                  surveyList.map((survey, index) => (
                    <tr key={survey.id || index}>
                      <td scope="row">{++index}</td>
                      <td onClick={() => redirectToResponseList(survey)}>
                        <div
                          className="d-flex align-items-center gap-2 text-capitalize "
                          style={{ cursor: "pointer" }}
                        >
                          {survey?.surveyDetails?.title
                            ? survey?.surveyDetails?.title
                            : "-"}{" "}
                        </div>
                      </td>

                      <td>
                        {survey?.surveyDetails?.description
                          ? survey?.surveyDetails?.description
                          : "-"}
                      </td>
                      <td>
                        {" "}
                        {new Date(survey?.createdAt).toLocaleString("en-US", {
                          hour12: true,
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          // second: '2-digit'
                        })}
                      </td>

                      <td>
                        <div className="d-flex gap-2">
                          <a
                            className="edit-del-icon eye-edit-del eye-img"
                            onClick={() => {
                              redirectToResponseList(survey);
                            }}
                          >
                            <img src={eyeimg} alt="view" />
                          </a>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      No Response Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      )}

      <div className="pagination-blk">
        <CustomPagination
          totalItems={totalItems}
          page={page}
          onPageChange={handleChangePage}
          limit={limit}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
    </div>
  );
}

export default ResponseSurveyList;
